import { render, staticRenderFns } from "./404.vue?vue&type=template&id=1cdd8b4a&scoped=true"
var script = {}
import style0 from "./404.vue?vue&type=style&index=0&id=1cdd8b4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cdd8b4a",
  null
  
)

export default component.exports